<template>
    <div class="product-type-edit" v-loading="loading">
        <h3>Créer une phrase</h3>

        <div class="d-flex flex-row mt-2 mb-5">
            <el-select placeholder='Choisir un titre' v-model="form.add_sentence_title">
                <el-option
                    v-for='(title, index) in product_type.title_description'
                    :key="index"
                    :label="title.value"
                    :value="index">
                </el-option>
            </el-select>

            <el-input placeholder="Phrase à insérer" v-model="form.add_sentence" @keydown.enter.prevent.native='addSentence'/>

            <el-button @click="addSentence" type="primary" icon="el-icon-plus"/>
        </div>

        <div v-for='(title, index_title) in product_type.title_description' class='mb-4'>
            <h2>{{ title.value }}</h2>

            <draggable v-model="product_type.title_description[index_title].sentences">
                <div v-for='(description, index_sentence) in title.sentences' :key='index_sentence'>
                    <el-input placeholder="titre" v-model="product_type.title_description[index_title].sentences[index_sentence]">
                        <template slot="prepend">
                            <el-button type="primary" >
                                <svg xmlns="http://www.w3.org/2000/svg" style="width:1.5em;height:1.5em;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                                </svg>
                            </el-button>
                        </template>
                        <slot slot="append">
                            <el-button @click="removeSentence(index_title, index_sentence)" type="primary" icon="el-icon-minus"></el-button>
                        </slot>
                    </el-input>
                </div>
            </draggable>
        </div>

        <el-button @click='$emit("close")'>Annuler</el-button>
        <el-button type="primary" @click="save">Sauvegarder</el-button>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { EventBus } from '../../event-bus';
    import Feature from '../../models/Feature';

    export default {
        components: {
            draggable,
        },
        props: {
            productTypeId: {
                required: true
            }
        },
        data() {
            return {
                loading: false,
                product_type: {},
                form: {
                    add_sentence: '',
                    add_sentence_title: null,
                },
            }
        },
        mounted() {
            this.fetch();
        },
        watch: {
            productTypeId() {
                this.fetch();
            }
        },
        methods: {
            fetch() {
                if (this.productTypeId === undefined) {
                    return;
                }

                this.loading = true;
                axios.get('/feature_value/' + this.productTypeId).then(response => {
                    this.product_type = response.data;
                    this.loading = false;
                });
            },
            addSentence() {

                if (this.form.add_sentence_title === null || this.form.add_sentence === '') {
                    return;
                }

                // Si le tableau sentences n'existe pas, on le crée
                if (!("sentences" in this.product_type.title_description[this.form.add_sentence_title])) {
                    this.product_type.title_description[this.form.add_sentence_title].sentences = [];
                }

                this.product_type.title_description[this.form.add_sentence_title].sentences.push(this.form.add_sentence);

                this.form.add_sentence = '';
            },
            removeSentence(index_title, index_sentence) {
                console.log(index_title, index_sentence)
                this.product_type.title_description[index_title].sentences.splice(index_sentence, 1);
            },
            save() {
                this.loading = true;
                axios.post('/features/' + this.product_type.feature_id + '/values/' + this.product_type.id, {
                    title_description: this.product_type.title_description,
                    mode: 'title_description'
                }).then(response => {
                    this.loading = false;
                    this.$emit('close');
                });
            },
        }
    };
</script>

<style scoped>

</style>
